import * as svg from "../../../assets/message-outline-icon.svg";

import {iconBuilder} from "./iconBuilder";

const MessagingOutlineIcon = iconBuilder(svg, "MessagingOutlineIcon", "0 0 21 20");

export default MessagingOutlineIcon;
